const actionCamperSetData = data => ({
  type: 'CAMPER_SET_DATA', payload: data,
})

export { actionCamperSetData }
